export const camelToUnderscore = (key: string) =>
  key.replace(/([A-Z])/g, '_$1').toLowerCase();

/**
 * Formats object keys to snake case convention
 * @param {record} Record object with camel case keys
 * @returns {Record} transformed record
 */
export const camelCaseToSnakeCase = (record: Record<string, any>) => {
  const transformedRecord: Record<string, any> = {};

  for (let camelKey in record) {
    transformedRecord[camelToUnderscore(camelKey)] = record[camelKey];
  }

  return transformedRecord;
};
